import I18n from "i18n-js";
import { makeAutoObservable } from "mobx";
import { DEFAULT_FULFILLMENT_TYPE, } from "../../ordering";
import { toPairs } from "../../core";
import { ErrorBox, CheckboxFieldController, SelectableFieldController, } from "../../form";
import { StreetAddressFormController } from "./StreetAddressFormController";
import { ApartmentInfoController } from "./ApartmentInfoController";
import { Availability } from "../../ordering/Availability";
export class FulfillmentMethodController {
    constructor(params) {
        this.fulfillmentInstructions = params.fulfillmentInstructions;
        this.apartmentInfoController = ApartmentInfoController.create(params.fulfillmentInstructions.deliveryAddress.apartmentInfo);
        this.streetAddressController = new StreetAddressFormController({
            streetAddress: params.fulfillmentInstructions.deliveryAddress.streetAddress,
            geocodingService: params.geocodingService,
            geolocationService: params.geolocationService,
            onChange: () => {
                if (params.viewType === "Cart") {
                    this.apartmentInfoController.clear();
                }
            },
        });
        this.fulfillmentMethod = new SelectableFieldController({
            initialValue: params.fulfillmentInstructions.fulfillmentMethodType ===
                "NoContactDelivery"
                ? "Delivery"
                : params.fulfillmentInstructions.fulfillmentMethodType,
            onUpdate: (value) => {
                if (value === "Delivery" &&
                    params.fulfillmentInstructions.fulfillmentMethodType ===
                        "NoContactDelivery") {
                    return;
                }
                params.fulfillmentInstructions.fulfillmentMethodType = value;
            },
            onClear: () => {
                params.fulfillmentInstructions.fulfillmentMethodType =
                    DEFAULT_FULFILLMENT_TYPE;
            },
            options: ["DineIn", "Delivery", "Takeaway"],
            errorBox: new ErrorBox({
                domainObjects: [this.fulfillmentInstructions],
                errorMessages: {
                    FulfillmentMethodTypeMissing: I18n.t("_common.form.errors.required"),
                },
            }),
        });
        this.noContactDelivery = new CheckboxFieldController({
            initialValue: params.fulfillmentInstructions.fulfillmentMethodType ===
                "NoContactDelivery",
            onUpdate: (value) => {
                params.fulfillmentInstructions.fulfillmentMethodType = value
                    ? "NoContactDelivery"
                    : "Delivery";
            },
        });
        makeAutoObservable(this);
    }
    get fields() {
        return {
            fulfillmentMethod: this.fulfillmentMethod,
            ...this.streetAddressController.fields,
            ...this.apartmentInfoController.fields,
            noContactDelivery: this.noContactDelivery,
        };
    }
    get fieldsArray() {
        return toPairs(this.fields).map(([_, field]) => field);
    }
    get isDirty() {
        return this.fieldsArray.some((field) => field.isDirty);
    }
    get isTouched() {
        return this.fieldsArray.some((field) => field.isTouched);
    }
    get isInvalid() {
        const controllerAvailability = Availability.composite([
            this.fulfillmentInstructions.fulfillmentMethodTypeAvailability,
            this.fulfillmentInstructions.deliveryAvailability,
        ]);
        return controllerAvailability.isAvailable.isDefinitelyFalse;
    }
    get isValid() {
        return !this.isInvalid;
    }
    get domain() {
        return this.fulfillmentInstructions;
    }
    submit() {
        this.fieldsArray.forEach((field) => field.blur());
    }
}
